class FinancialInfoController {
    private onUpdate: any;
    private account: any;

    constructor(private $state: ng.ui.IStateService) {
        'ngInject';
        // console.log('FinancialInfoController');
    }

    submitFinancialInfo() {
        // console.log('update FinancialInfo');

        this.onUpdate({ account: this.account });

        (<any>$('#financialInfoModal')).modal('hide');
    }
}

export const financialInfoComponent = {
    bindings: {
        account: '<',
        onUpdate: "&"
    },
    controller: FinancialInfoController,
    template: require('./financialInfoModal.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/accounts/financialInfoModal.component.ts